import { render, staticRenderFns } from "./RecordSearch.vue?vue&type=template&id=0c49e278&scoped=true"
import script from "./RecordSearch.vue?vue&type=script&lang=js"
export * from "./RecordSearch.vue?vue&type=script&lang=js"
import style0 from "./RecordSearch.vue?vue&type=style&index=0&id=0c49e278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c49e278",
  null
  
)

export default component.exports